import { BaseQuery } from './BaseQuery';
import { IExecutionOptions } from '../models/query';
import { ConditionalHelper } from '../helpers/ConditionalHelper';
import { IDocument } from '../models/api/search';
import { isArrayLike } from '../utils/isArrayLike';
import { Query } from './Query';

export class DocumentQuery extends BaseQuery {
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { collectionItemConditional, index = -1, startIndex = -1 } = this.options;
		let documents: IDocument[] = [];
		if (this.options.entityType) {
			documents = this.getSubCollection(executionOptions);
		}
		else {
			const context = Query.getContext(executionOptions, this.options);
			if (context) {
				const { globalDocuments } = context;
				documents = globalDocuments;
			}
		}

		const conditionalHelper = new ConditionalHelper({ conditions: [] }, this.translationHelper);
		documents = documents.filter((document) => {
			return !collectionItemConditional ||
				conditionalHelper.matches(document, collectionItemConditional);
		});
		// Set up the _fields property with the properties we want
		let response: any = documents.map((document) => {
			(document as any)._fields = this.getDocumentResult(document);
			return document;
		}) as any;

		if ((index > -1 || startIndex > -1) && isArrayLike(response)) {
			response = this.getItem(executionOptions, response);
		}

		return response;
	}
	getDocumentResult<T>(document: IDocument): T {
		const { fields } = this.options;
		if (!fields || fields.length === 0) {
			const { key, childKey } = this.options;
			return this.getDocumentField(document, key, childKey) as any;
		}

		const documentResult: any = {};
		for (const field of fields) {
			const { name, key, childKey } = field;
			documentResult[name] = this.getDocumentField(document, key, childKey);
		}
		return documentResult;
	}
	getDocumentField<T>(document: IDocument, key: string = null, childKey: string = null): T {
		if (document) {
			if (key) {
				const { meta, inferred } = document;
				if (key === 'meta' && meta) {
					return childKey &&  meta[childKey] && meta[childKey].value;
				}
				if (key === 'inferred' && inferred) {
					return childKey &&  inferred[childKey] && inferred[childKey].value;
				}
				return document[key];
			}
			return document as any;
		}
		return;
	}
}